import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIIcon from 'UIComponents/icon/UIIcon';
import { SplitModuleIcon } from 'foundations-assets';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Fragment } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ForecastingDealSplitIcon = ({
  tooltipDisabled
}) => {
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(UIIcon, {
        className: "m-right-1",
        name: "splitModule"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dealTable.bulkActions.dealSplitApplied"
      })]
    }),
    disabled: tooltipDisabled,
    children: /*#__PURE__*/_jsx(IconHolder, {
      "data-test-id": "deal-split-icon",
      color: "icon-primary-default",
      icon: SplitModuleIcon,
      size: "200"
    })
  });
};